import { render, staticRenderFns } from "./policyEdit.vue?vue&type=template&id=1006fd18"
import script from "./policyEdit.vue?vue&type=script&lang=js"
export * from "./policyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports